module.exports = __webpack_public_path__ + "static/media/f-story-icon-white.fca0fb2e.png";